function refreshCartDrawerFreeShippingMessage(root = document) {
  const scope = root instanceof Element || root instanceof Document ? root : document;
  const bars = scope.querySelectorAll('.free_shipping--bar');

  bars.forEach((bar) => {
    bar.classList.add('free_shipping--bar--unlocked');

    const icon = bar.querySelector('.free-shipping__icon');
    if (icon) {
      icon.innerHTML = `
        <svg viewBox="0 0 20 20" focusable="false" aria-hidden="true">
          <path d="M10 18.25C5.44 18.25 1.75 14.56 1.75 10S5.44 1.75 10 1.75 18.25 5.44 18.25 10 14.56 18.25 10 18.25Zm-1.03-5.14 5-5a.75.75 0 1 0-1.06-1.06l-4.47 4.47-1.8-1.8a.75.75 0 0 0-1.06 1.06l2.33 2.33c.29.29.77.29 1.06 0Z"/>
        </svg>
      `;
    }

    const message = bar.querySelector('.free-shipping__message > div');
    if (message) {
      message.innerHTML = `
        <h4>Fast, Free Shipping Included</h4>
        <p>No minimums on qualifying orders. West Coast orders may include a small regional surcharge.</p>
      `;
    }

    const progressBar = bar.querySelector('.free_shipping_progress_bar');
    if (progressBar) {
      progressBar.remove();
    }
  });
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.fetchRecommendationsFromDrawer();
    refreshCartDrawerFreeShippingMessage(this);
  }

  setHeaderCartIconAccessibility() {
    const cartLinkArray = document.querySelectorAll('[data-cart-icon-bubble], #cart-icon-bubble');

    cartLinkArray.forEach(cartLink => {
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink)
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    })
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    refreshCartDrawerFreeShippingMessage(this);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => { this.classList.add('animate', 'active') });

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
    document.dispatchEvent(new CustomEvent('shopify:cart-drawer-open'));
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

    fetchRecommendationsFromDrawer() {
      // find the recommendation data wrapper
      const wrapper = this.querySelector('[data-product-id]');
      if (!wrapper) {
        return;
      }

      const productId = wrapper.getAttribute('data-product-id');
      const baseUrl = wrapper.getAttribute('data-base-url');

      if (!productId || !baseUrl) {
        return;
      }

      const url = `${baseUrl}=${productId}&limit=4`;

      fetch(url)
        .then(res => res.json())
.then(data => {
          this.renderRecommendations(data.products || []);
        })
        .catch(() => {});
    }

    
      renderRecommendations(products) {
        const wrapper = this.querySelector("#cart_drawer_recommendations .swiper-wrapper");

        if (!wrapper) {
          return;
        }

        wrapper.innerHTML = ''; // clear old slides

        products.forEach(product => {

          // skip Shipping Protection
          if (product.title === "Shipping Protection") return;

          // skip products that require a selling plan
          const requiresSubscriptionOnly =
            product.variants?.every(v => v.selling_plan_allocations?.length > 0) ||
            product.variants?.some(v => v.requires_selling_plan);

          if (requiresSubscriptionOnly) {
              return;
          }

          // safe variant ID
          const variant = product.variants?.[0];
          const variantId = variant?.id || product.id;

          // proceed with your existing rendering
          const slide = document.createElement('div');
          slide.className = 'swiper-slide';

          slide.innerHTML = `
            <div class="drawer-recommendation-card">
              <div class="drawer-rec-image">
                <img src="${product.featured_image}" alt="${product.title}">
              </div>
              <div class="drawer-recommendation-info">
                <h4 class="drawer-recommendation-title">${product.title}</h4>
                <div class="drawer-rec-price">$${(product.price / 100).toFixed(2)}</div>

                <product-form class="product-form drawer-rec-product-form">
                  <form method="post" action="/cart/add"
                    accept-charset="UTF-8" class="form" enctype="multipart/form-data"
                    novalidate="novalidate" data-type="add-to-cart-form">

                    <input type="hidden" name="form_type" value="product">
                    <input type="hidden" name="utf8" value="✓">
                    <input type="hidden" name="id" value="${variantId}">

                    <div class="product-form__buttons">
                      <button type="submit" name="add"
                        class="product-form__submit button button--full-width button--primary"
                        aria-haspopup="dialog">

                        <span>Add to cart</span>
                        <div class="loading-overlay__spinner hidden">
                          <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66">
                            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                          </svg>
                        </div>

                      </button>
                    </div>

                    <input type="hidden" name="product-id" value="${product.id}">
                    <input type="hidden" name="section-id" value="cart-drawer">
                  </form>
                </product-form>

              </div>
            </div>
          `;

          wrapper.appendChild(slide);

        });


      // document.querySelectorAll(".drawer-rec-atc").forEach((btn) => {
      //   btn.addEventListener("click", () => {
      //     debugger;
      //     console.log(this);
      //     addRecommendedItem(btn.dataset.variantId, btn, this);
      //   });
      // });


  this.initializeRecommendationsSwiper();
}

  initializeRecommendationsSwiper() {
    if (typeof Swiper === 'undefined') return;

    if (this.recSwiper) {
      this.recSwiper.destroy(true, true);
    }

    this.recSwiper = new Swiper('#cart_drawer_recommendations .cart-drawer-recommendations', {
      slidesPerView: 1.08,
      spaceBetween: 12,
      grabCursor: true,
      breakpoints: {
        0: { slidesPerView: 1.06 },
        540: { slidesPerView: 1.18 }
      }
    });
  }



  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    refreshCartDrawerFreeShippingMessage(this);

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      
      // Fetch recommendations after drawer is updated
      this.fetchRecommendationsFromDrawer();
      refreshCartDrawerFreeShippingMessage(this);
    });
    // updateShippingDisplay();
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);



/* ===========================
   Cart Drawer Recommendations
   Option C: Merge recommendations from ALL cart items
   =========================== */


// Calculate the height of the drawer components
function updateCartDrawerHeights() {
  const html = document.documentElement;

  const header = document.querySelector(".drawer__header");
  const freeBar = document.querySelector(".free_shipping--bar");
  const wrapper = document.querySelector(".drawer-items-and-recommendations-wrapper");
  const recommendations = document.querySelector("cart-drawer #cart_drawer_recommendations");
  const footer = document.querySelector("cart-drawer .drawer__footer");
  const drawer_item = document.querySelector("#CartDrawer-Item-1");

  const headerHeight = header?.offsetHeight || 0;
  const freeBarHeight = freeBar?.offsetHeight || 0;
  const wrapperHeight = wrapper?.offsetHeight || 0;
  const recommendationsHeight = recommendations?.offsetHeight || 0;
  const footerHeight = footer?.offsetHeight || 0;
  const drawerItemHeight = drawer_item?.offsetHeight || 0;

  const totalHeight =
    headerHeight + freeBarHeight + wrapperHeight + recommendationsHeight + footerHeight;

  // Write CSS variables to <html>
  html.style.setProperty("--drawer-header-height", `${headerHeight}px`);
  html.style.setProperty("--drawer-free-bar-height", `${freeBarHeight}px`);
  html.style.setProperty("--drawer-wrapper-height", `${wrapperHeight}px`);
  html.style.setProperty("--drawer-recommendations-height", `${recommendationsHeight}px`);
  html.style.setProperty("--drawer-footer-height", `${footerHeight}px`);
  html.style.setProperty("--drawer-total-height", `${totalHeight}px`);
  html.style.setProperty("--drawer-item-height", `${drawerItemHeight}px`);
}

window.updateCartDrawerHeights = updateCartDrawerHeights;

// Run on load
window.addEventListener("load", () => {
  updateCartDrawerHeights();
  refreshCartDrawerFreeShippingMessage();
});

// Run on resize (debounced)
let resizeTimer;
window.addEventListener("resize", () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(updateCartDrawerHeights, 150);
});
